<app-modal-alert
	*ngIf="openAlert"
	[value]="valueModalDelete"
	[nameModal]="nameModal"
	[elementsDelete]="elementsDelete"
	(closeModalAlert)="closeModalAlert($event)"
></app-modal-alert>
<div class="overflow-y-auto overflow-x-hidden">
	<app-header-views
		[title]="translateSystemModules.title"
		[textButton]="translateSystemModules.buttonNew"
		[hoverButton]="translateSystemModules.hoverButtonNew"
		(actionButton)="openDialogModule()"
	></app-header-views>

	<div class="content-view">
		<app-sub-sidebar
			[tamMinWidhtSibSidebar]="210"
			[tamWidhtSibSidebar]="250"
			[tamHeightSibSidebar]="162"
			(searchText)="searchSidebar($event)"
		>
			<div class="cards flex flex-col items-center">
				<div *ngIf="!isLoadingCard">
					<div
						class="card"
						[matTooltip]="systemsModule.name"
						[matTooltipPosition]="'right'"
						*ngFor="let systemsModule of modules"
						[ngClass]="{ 'card-module-select': systemsModule?.pk === moduleSelect!.pk }"
					>
						<div class="settings-module relative">
							<div class="w-full" (click)="selectedModule(systemsModule)"></div>
							<mat-icon class="icon-material" (click)="menu.toggle($event)"> settings </mat-icon>
							<p-menu #menu [popup]="true" [model]="systemsModule.items || []"></p-menu>
						</div>
						<div
							class="flex justify-center items-center h-[100px]"
							(click)="selectedModule(systemsModule)"
						>
							<img
								imgNotFound
								class="w-[130px] h-[90px] object-contain"
								[src]="systemsModule.logo"
							/>
						</div>
						<div class="flex flex-col h-full">
							<div class="name h-full" (click)="selectedModule(systemsModule)">
								<p class="w-full h-full pl-2">
									<span>
										{{ systemsModule.name | titlecase }}
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				<app-loading-spinner *ngIf="isLoadingCard"></app-loading-spinner>
			</div>
		</app-sub-sidebar>

		<div class="hidden md:flex md:flex-col bg-white view-system">
			<div class="not-selected h-full" *ngIf="!moduleSelect.sk">
				<div class="content-not-selected h-full flex items-center flex-col justify-center">
					<img src="../../../../assets/icon/notFile.svg" alt="" />
					<span class="notFount">{{ translateSystemModules.textNotSelected }}</span>
				</div>
			</div>
			<div *ngIf="moduleSelect.sk">
				<div class="h-[80px] flex justify-between items-center border-b-neutral-color-i border-b">
					<div
						class="h-[80px] flex flex-col font-normal items-start justify-center px-4 font-lato text-complementary-color-b"
					>
						<h1 class="text-[24px]">{{ moduleSelect.name | titlecase }}</h1>
						<h2 class="text-xs">PK: {{ moduleSelect.pk }}</h2>
						<h2 class="text-xs">SK: {{ moduleSelect.sk }}</h2>
					</div>
					<div class="px-4">
						<app-tabs
							(active)="viewSelected = $event"
							[view]="viewSelected"
							[tabs]="tabs"
						></app-tabs>
					</div>
				</div>
				<div [ngSwitch]="viewSelected" class="h-[calc(100vh-188px)]">
					<div *ngSwitchCase="'resources'">
						<app-resources
							[moduleSelect]="moduleSelect"
							[translate]="translateSystemModules"
							[filterList]="filterList"
							[columnsFilter]="columnsFilter"
							[pagination]="paginationResource"
							[isLoading]="isLoading"
							[rowsFilter]="rowsFilter"
						></app-resources>
					</div>
					<div *ngSwitchCase="'versions'">
						<app-versions
							[translate]="translateSystemModules"
							[moduleSelect]="moduleSelect"
							[isLoading]="isLoadingVersions"
							[version]="versions"
							[pagination]="paginationVersion"
						></app-versions>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
